import React, { useEffect, useRef, useState } from "react";
import topSvg from "../../assets/svg/top.svg";
import bottomSvg from "../../assets/svg/bottom.svg";
import mainLogoSvg from "../../assets/img/Main logo.png";
import svg41 from "../../assets/svg/svg41.svg";
import emblemSvg from "../../assets/img/emblem.png";
import niaImg from "../../assets/img/nia-logo.png";
import nwhsaImg from "../../assets/img/nwhsa-logo.png";
import { Divider, Form, Input, Radio, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { fetchData } from "../../features/fetch/fetchSlice";

const items = [
  {
    title1: "SDI",
    title2: "State Department For Irrigation",
    svg: "emblemSvg",
  },
  {
    title1: "NIA",
    title2: "National Irrigation Authority",
    svg: "niaImg",
  },
  {
    title1: "NWHSA",
    title2: "National Water Harversting and Storage Authority",
    svg: "nwhsaImg",
  },
];
function AccountLogin() {
  const url = "api/v2/stateAgency/get";
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef(null);

  const { saving } = useSelector((state) => state.save);
  const { authLoading } = useSelector((state) => state.auth);
    const { loading, data } = useSelector((state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],    
    }));

  const onFinish = async (data) => {
    if (!selectedValue) {
      toast.error("Select account");
      return;
    }
    await navigate("/dashboard-main");
    // const res = await dispatch(
    //   save({
    //     usrSecret: cancatenatedString,
    //     url: "api/v1/payments/verify-payment-otp",
    //   })
    // );
    // if (res?.payload?.success) {
    //   await toast.success(res.payload?.messages?.message);
    //   await setIsInputEmpty(true);
    //   await setVerificationCode(["", "", "", ""]);
    //   await form.resetFields();
    //   await navigate("/dashboard-main");
    // } else {
    //   toast.error(res.payload?.messages?.message);
    // }
  };

  const handleCancel = async () => {
    await navigate("/login");
  };

  const [selectedValue, setSelectedValue] = useState(null);
  const onChange = (newValue) => {
    setSelectedValue((prevValue) => (prevValue === newValue ? null : newValue));
  };

  const svgMap = {
    emblemSvg,
    niaImg,
    nwhsaImg,
  };
  const processedData = items?.map((item) => ({
    ...item,
    svg: svgMap[item?.svg],
  }));

  async function fetchAccountData() {
    await dispatch(
      fetchData({
        url: url,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    fetchAccountData();
  }, []);

  // console.log("data",data)

  return (
    <div className="w-full h-full min-h-screen flex flex-col op-bg">
      <div>
        <img src={topSvg} alt="topSvg" />
      </div>
      <div className="w-full flex flex-col h-full lg:px-0 px-3 lg:items-center lg:justify-center ">
        <div className="login-card lg:p-[2.5rem] p-3">
          <div>
            <img src={mainLogoSvg} alt="mainLogoSvg" />
          </div>
          <div className="typography_1 mt-[2.5rem]">Select Account type</div>

          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            style={{
              maxWidth: "100%",
            }}
            className="lg:w-[30.6875rem] w-full"
            form={form}
          >
            {processedData &&
              processedData?.map((item, index) => (
                <div key={index} className="mt-[2rem]">
                  <div
                    className={`acct-card cursor-pointer ${
                      selectedValue === item.title1
                        ? "border border-[#0092CC] !bg-[#F7F7F7]"
                        : "border border-[#D6E1F5]"
                    }`}
                    onClick={() => onChange(item.title1)}
                  >
                    <div className="flex justify-between">
                      <div className="flex items-center gap-x-[1.75rem]">
                        <img src={item?.svg} alt={item?.svg} />
                        <div className="flex flex-col gap-y-[.62rem]">
                          <span className="!font-[600] typography_1">
                            {item?.title1}
                          </span>
                          <span className="acct-sub">{item?.title2}</span>
                        </div>
                      </div>
                      <div>
                        <Radio checked={selectedValue === item?.title1} />
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            <div className="flex justify-center w-full mt-[2rem]">
              <button
                className="cstm-btn-2"
                type="submit"
                disabled={authLoading ? true : false}
              >
                {authLoading ? <Spin /> : "Proceed"}
              </button>
            </div>

            <div className="mt-[2.5rem]">
              <Divider />
            </div>

            <div
              className="mt-[1.25rem] flex items-center gap-x-[1rem] cursor-pointer"
              onClick={handleCancel}
            >
              <img src={svg41} alt="svg41" />
              <span className="back">Back to login</span>
            </div>
          </Form>
        </div>
      </div>
      <div className="w-full  mt-auto flex items-center justify-center bottom-0">
        <img src={bottomSvg} alt="bottomSvg" />
      </div>
    </div>
  );
}

export default AccountLogin;
